import { render } from "./create.vue?vue&type=template&id=25b4a196"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./create.vue?vue&type=style&index=0&id=25b4a196&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__